import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, useParams } from 'react-router-dom';
import Button from '../components/Button';
import PText from '../components/PText';
import SectionTitle from '../components/SectionTitle';
import AboutImg from '../assets/images/about-sec-img.png';
import projects from '../assets/data/projects';

const ProjectDetailsStyles = styled.div`
  padding: 10rem 0;
  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    text-align: left;
  }
  .other-photos {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 30px;
  }
  .other-photos img {
    border-radius: 2px solid black;
    width: 100%;
    heigh: 100%;
  }
  .ProjectDetails__left,
  .ProjectDetails__right {
    flex: 1;
  }
  .section-title {
    text-align: left;
  }
  .para {
    margin-top: 2rem;
    margin-left: 0;
  }
  .ProjectDetails__buttons {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 2rem;
    margin-top: 2rem;
  }
  .underline {
    width: 25%;
  }
  .link-button {
    background-color: darkgrey;
    color: black;
    border-radius: 5px;
    padding: 10px;
    margin-top: 100px;
    font-size: 15px;
    font-weight: 500;
  }
  @media only screen and (max-width: 950px) {
    .ProjectDetails__left {
      flex: 4;
    }
    .ProjectDetails__right {
      flex: 3;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      text-align: center;
    }
    .ProjectDetails__left,
    .ProjectDetails__right {
      width: 100%;
    }
    .ProjectDetails__right {
      margin-top: 3rem;
    }
    .section-title {
      text-align: center;
    }
    .para {
      margin: 0 auto;
      margin-top: 2rem;
    }
    .ProjectDetails__buttons {
      flex-direction: column;
      gap: 0rem;
      .button-wrapper,
      a {
        width: 100%;
        text-align: center;
      }
    }
  }
`;

export default function ProjectDetails() {
  const { id } = useParams();
  const [project, setProject] = useState();
  useEffect(() => {
    setProject(projects[id - 1]);
  }, [project]);
  const p = { ...project };
  // console.log(project);
  return (
    <ProjectDetailsStyles>
      <div className="container">
        <div className="ProjectDetails__left">
          <SectionTitle subheading="Let's explore..." heading={p.name} />
          <PText>{p.overview}</PText>

          <PText>Description...</PText>
          <hr className="underline" />
          <PText>{p.desc}</PText>

          <PText>Requirements..</PText>
          <hr className="underline" />
          <PText>{p.req}</PText>

          <div className="ProjectDetails__buttons">
            <a
              href={p.liveLink}
              target="_blank"
              rel="noreferrer noopener"
              className="link-button"
            >
              Visit Website
            </a>
            <a
              href={p.clientLink}
              target="_blank"
              rel="noreferrer noopener"
              className="link-button"
            >
              Github Repository
            </a>
            {p.serverLink !== '' ? (
              <a
                href={p.serverLink}
                target="_blank"
                rel="noreferrer noopener"
                className="link-button"
              >
                Server Repository
              </a>
            ) : (
              <h1> </h1>
            )}
          </div>
        </div>
        <div className="ProjectDetails__right">
          <img className="aboutImg" src={p.img1} alt="Img" />
          <div className="other-photos">
            <img className="aboutImg" src={p.img2} alt="Img" />
            <img className="aboutImg" src={p.img3} alt="Img" />
            <img className="aboutImg" src={p.img4} alt="Img" />
          </div>
        </div>
      </div>
    </ProjectDetailsStyles>
  );
}
